export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7161.3392dd75.jpg";